import { render, staticRenderFns } from "./scheduleReminder.vue?vue&type=template&id=67908a36&"
import script from "./scheduleReminder.vue?vue&type=script&lang=js&"
export * from "./scheduleReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports